/**
 * Split keyName by '/' and '.', but do not split on '.' if followed by a number. Consecutive dots are
 * not allowed handled gracefully so must be filtered out after the fact if not needed.
 *
 * Regex explanation:
 * \/: Matches the forward slash / character.
 * |: Logical OR operator. The regex will match either the pattern before or after this symbol.
 * \.: Matches the dot . character literally.
 * (?!\d): Negative lookahead that ensures the dot . is not followed by a digit (\d).
 *
 * @examples
 * "foo/bar.baz123.qux"    → ["foo", "bar", "baz123", "qux"]
 * "example/test.456.file" → ["example", "test.456", "file"]
 * "alpha.beta/.delta"     → ["alpha", "beta", "", "delta"]
 *
 * @param keyName
 * @returns
 */
export const getKeyNameParts = (keyName: string): string[] => {
  return keyName.split(/\/|\.(?!\d)/);
};
